import { render } from "./ApartmentsTable.vue?vue&type=template&id=1927e6a6&scoped=true"
import script from "./ApartmentsTable.vue?vue&type=script&lang=js"
export * from "./ApartmentsTable.vue?vue&type=script&lang=js"

import "./ApartmentsTable.vue?vue&type=style&index=0&id=1927e6a6&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1927e6a6"]])

export default __exports__